import { Badge, Gray100, typeCompact14MediumProperties } from '@traceair/tds';
import React from 'react';
import { stylesheet } from 'typestyle';
import { formatDate } from '../../../../libs/dates';
import { MissionData } from '../types';
import { getDateHtmlId } from '../helpers/htmlIds';

const css = stylesheet({
  header: {
    marginBottom: 14,
  },
  date: {
    ...typeCompact14MediumProperties,
  },
  badge: {
    marginLeft: 8,
    $nest: {
      '&&': {
        color: Gray100,
      },
    },
  },
});

interface Props {
  date: string;
  schedules: MissionData[];
}

export const ScheduleHeader = ({ date, schedules }: Props) => {
  const count = schedules.length;

  return (
    <div id={getDateHtmlId(date)} className={css.header}>
      <span className={css.date}>{formatDate({ date, withWeekday: true })}</span>
      <Badge className={css.badge} label={count} />
    </div>
  );
};
